<template>
  <Html :lang="head.htmlAttrs.lang" :dir="head.htmlAttrs.dir">
    <Head>
      <Title v-if="title">{{ title }}</Title>
      <Meta name="description" :content="description" />
      <Meta name="og:description" :content="description" />
      <Meta property="fb:app_id" :content="fbAppId" />
      <Meta
        v-if="pageData?.meta_keyword"
        name="keywords"
        :content="pageData?.meta_keyword"
      />
      <template v-for="link in head.link" :key="link.id">
        <Link
          :id="link.id"
          :rel="link.rel"
          :href="link.href"
          :hreflang="link.hreflang"
        />
      </template>
      <template v-for="meta in head.meta" :key="meta.id">
        <Meta :id="meta.id" :property="meta.property" :content="meta.content" />
      </template>
    </Head>
    <Body>
      <div class="sticky top-0 z-40"><TopbarRibbon /> <MainNavigation /></div>
      <slot />
      <FooterSecureCheckout />
      <FooterMarqueen />
      <FooterNavigation />
    </Body>
  </Html>
</template>

<script lang="ts" setup>
import { seoRepository } from '~/repository/seoRepository'

const route = useRoute()
const { locale } = useI18n()
const appConfig = useAppConfig()
const fbAppId = appConfig.fbAppId as string
const head = useLocaleHead({
  addDirAttribute: true,
  identifierAttribute: 'id',
  addSeoAttributes: true
})

const { $serverApi } = useNuxtApp()
const seoRepo = seoRepository($serverApi)

const { data: pageData } = await useAsyncData(
  'getStaticSeoGeneral',
  async () => {
    const data = await seoRepo.getSeo('general')
    return data
  }
)

const title = computed(() =>
  route.meta.title
    ? (route.meta.title as string)
    : locale.value === 'en'
      ? pageData.value?.meta_title?.en
      : pageData.value?.meta_title?.th || pageData.value?.meta_title?.en
)

const description = computed(() =>
  route.meta.description
    ? (route.meta.description as string)
    : locale.value === 'en'
      ? pageData.value?.meta_description?.en
      : pageData.value?.meta_description?.th ||
        pageData.value?.meta_description?.en
)

// setup head template
useHead({
  titleTemplate: '%s'
})

useSeoMeta({
  ogImage: pageData.value?.og_image
})
</script>
